var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSendMessage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9719 6.97173C15.9719 7.37173 15.7336 7.7336 15.3654 7.89079L1.3938 13.9186C1.26687 13.9733 1.13305 13.9997 1.00037 13.9997C0.730834 13.9997 0.466303 13.8903 0.272865 13.6856C-0.0152288 13.3804 -0.08151 12.9278 0.105865 12.5522L2.40774 7.94904L9.97337 6.99998L2.40724 6.04986L0.105365 1.44673C-0.0819163 1.07173 -0.0155163 0.618921 0.272553 0.313922C0.561615 0.00873434 1.0088 -0.0845156 1.39349 0.0810156L15.3938 6.08111C15.7626 6.23736 15.9719 6.59986 15.9719 6.97173Z",
    fill: "#78878B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMessage);
export default __webpack_public_path__ + "static/media/send-message.afafd49d56e4ae4b8ee4db4958772b0e.svg";
export { ForwardRef as ReactComponent };